
<template>
  <div
      v-if="showMessage"
      :class="['notification__message', `notification__message--${messageType}`]"
  >
    <span v-html="messageText"></span>
    <button
        class="notification-close"
        @click.stop="showMessage = false"
        aria-label="Close notification"
    >×</button>
  </div>
</template>

<script>
import { useNotificationStore } from '~/stores/notification';
import { nextTick } from "#imports";

export default {
  setup() {
    return {
      notificationStore: useNotificationStore(),
    }
  },
  props: {
    messageText: String,
    messageType: String ['error', 'success'],
    storedMessage: Boolean,
    disableTimeout: Boolean,
    disableScroll: Boolean,
    timeoutDuration: {
      type: Number,
      default: 4000,
    },
  },
  data() {
    return {
      showMessage: true,
    }
  },
  mounted() {
    this.displayMessage()
  },
  methods: {
    displayMessage() {
      this.showMessage = true;
      if (! this.disableTimeout) {
        this.autoTimeout()
      }

      nextTick().then(() => {
        if (! this.disableScroll) {
          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }, 800);
        }
      });
    },
    autoTimeout() {
      nextTick().then(() => {
        setTimeout(() => {
            this.showMessage = false;
            if (this.storedMessage) {
              this.notificationStore.clearNotification()
            }
        }, this.timeoutDuration);
      });
    },
  },
  watch: {
    messageText(newMessage) {
      if (newMessage) {
        this.displayMessage()
      } else {
        // hide element if empty
        this.showMessage = false
      }
    }
  },
}
</script>

<style lang="scss">
@use "~/common/scss/message";
@use "~/common/scss/mq" as *;
@use "~/common/scss/variables" as *;

.notification {
  @include message.responseMessage();
  &__message {
    margin: 1rem;
    cursor: pointer;
    position: relative;
    padding-right: 3rem;
    padding-left: 1.5rem;
  }
}

.notification-close {
  color: #5b9d54;
  position: absolute;
  right: .5rem;
  top: 47.5%;
  transform: translateY(-50%);
  font-size: 3rem;
  line-height: 1;
  cursor: pointer;
  opacity: 0.85;
  width: 3rem;

  @include mq($bp-0, $bp-2) {
    font-size: 2.5rem;
  }
}
</style>
